<div class="blotter-dialog-container">
  <ag-grid-angular
    class="ag-bcdfx"
    enableColResize
    enableSorting
    (contextmenu)="handleClick($event)"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [showToolPanel]="false"
  >
  </ag-grid-angular>
  <bfx-blotter-column-selector
    class="blotter-dialog-empty-body-element"
    [currentLadderBlotter]="blotterInstance"
    bfxElementOnBody
  ></bfx-blotter-column-selector>

  <div class="blotter-dialog-form">
    <span>
      <bfx-text-input
        #commentInput
        [inputLabelText]="'Reason' + (mandatoryComment?' (required)':' (optional)')"
        autocomplete="off"
        [(ngModel)]="comment"
        size="sm"
        [disabled]="progressStatus > 0"
        size="sm"
        [maxLength]="100"
        width="100%"
        [ngClass]="{
        'comment-input':true
       }"
        [externalState]="externalState"
        (blur)="validateCommentInput($event)"
        (focus)="commentFocused = true"
      ></bfx-text-input>
    </span>
    <bfx-comment-warning></bfx-comment-warning>
  </div>

  <div class="blotter-dialog-footer">
    <div class="blotter-dialog-status" *ngIf="!showCancel">
      <div class="bfx-callout-negative-sm" *ngIf="message">
        <i class="icon-error"></i>
        <span>{{message}}</span>
      </div>
      <div class="progress-bar-container" *ngIf="!message">
        <div class="progress-bar-track"></div>
        <div class="progress-bar-indicator" [style.width.%]="progress"></div>
      </div>
    </div>

    <div class="flex-spacer"></div>
    <div class="action-button-group">
      <button
        *ngIf="showClose"
        pButton
        class="bfx-button-secondary-moderate"
        (click)="parentPopout.close()"
      >
        Close
      </button>
      <button
        *ngIf="showCancel"
        pButton
        class="bfx-button-negative"
        (click)="cancelOrders($event, commentInput)"
      >
        Cancel Orders
      </button>
      <button *ngIf="showAbort" pButton class="bfx-button-secondary-moderate" (click)="abort()">
        Abort
      </button>
      <button *ngIf="showReject" pButton class="bfx-button-negative-bold" (click)="reject()">
        Reject
      </button>
      <button *ngIf="showAccept" pButton class="bfx-button-primary-bold" (click)="accept()">
        Accept
      </button>
    </div>
  </div>
</div>
